var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#150349"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 24.1499V28.4C30.25 29.4944 29.4631 30.4359 28.3782 30.58C26.2915 30.857 24.1624 31 22 31C19.8376 31 17.7085 30.857 15.6218 30.58C14.5369 30.4359 13.75 29.4944 13.75 28.4V24.1499M30.25 24.1499C30.7219 23.7476 31 23.1389 31 22.4889V18.7057C31 17.6247 30.2321 16.6908 29.1631 16.5309C28.0377 16.3625 26.8995 16.2332 25.75 16.1443M30.25 24.1499C30.0564 24.315 29.8302 24.4453 29.5771 24.5294C27.1953 25.3212 24.6477 25.75 22 25.75C19.3523 25.75 16.8047 25.3212 14.4229 24.5294C14.1698 24.4452 13.9436 24.3149 13.75 24.1499M13.75 24.1499C13.2781 23.7476 13 23.1389 13 22.4889V18.7057C13 17.6248 13.7679 16.6908 14.8369 16.5309C15.9623 16.3625 17.1005 16.2332 18.25 16.1443M25.75 16.1443V15.25C25.75 14.0074 24.7426 13 23.5 13H20.5C19.2574 13 18.25 14.0074 18.25 15.25V16.1443M25.75 16.1443C24.5126 16.0487 23.262 16 22 16C20.738 16 19.4874 16.0487 18.25 16.1443M22 22.75H22.0075V22.7575H22V22.75Z",
    stroke: "#FCFCFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDefaultIcon);
export default __webpack_public_path__ + "static/media/notification-default-icon.60b6431236cc42b406b4c5556d82e0f0.svg";
export { ForwardRef as ReactComponent };